export function GetToken(){
    return sessionStorage.getItem("user");
}
export function SetToken(val){
    return sessionStorage.setItem("user",val)
}